// LeadMailer Design System — Card, reworked as a flat section.
//
// The original wrapped content in a rounded, bordered, shadowed panel floating
// on the app background. The flat rework keeps the same API (title / action /
// padded / children) but renders a section heading with a hairline rule and
// lets the content sit directly on the page — one continuous surface, no box.
// No call site needs to change.
import React from 'react'

export interface CardProps {
  title?: React.ReactNode
  action?: React.ReactNode
  padded?: boolean
  children?: React.ReactNode
  style?: React.CSSProperties
}

export function Card({ title, action, padded = true, children, style }: CardProps) {
  return (
    <section style={style}>
      {title != null && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 12,
            padding: '0 0 8px',
            borderBottom: '1px solid var(--border-default)',
          }}
        >
          <h2
            style={{
              margin: 0,
              // sentence case on a plain hairline — no caps, no accent
              fontSize: 15.5,
              fontWeight: 'var(--weight-semibold)' as React.CSSProperties['fontWeight'],
              lineHeight: 'var(--leading-snug)',
              color: 'var(--text-primary)',
            }}
          >
            {title}
          </h2>
          {action}
        </div>
      )}
      {/* padded only matters under a heading: forms get breathing room, tables sit flush */}
      <div style={{ paddingTop: title != null && padded ? 12 : 0 }}>{children}</div>
    </section>
  )
}
